import Bowser from 'bowser'

export default () => {
  if (typeof window !== 'undefined') {
    const browser = Bowser.getParser(window.navigator.userAgent)
    const browserInfo = browser.getBrowser()
    const name = browserInfo.name || ''
    const version = parseFloat(browserInfo.version || '0')

    const isUnsupported =
      name === 'Internet Explorer' ||
      (name === 'Edge' && !!version && version < 18) ||
      (name === 'Safari' && !!version && version < 12)

    return isUnsupported
  }
}
